import React from 'react';
import { Authenticator, useAuthenticator, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';
import { CircularProgress, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';

I18n.putVocabularies(translations);

I18n.putVocabularies({
  ja: {
    'Sign Up': 'サインアップ',
    'Enter your email': 'メールアドレスを入力',
    'Enter your password': 'パスワードを入力',
    'Create Account': 'アカウントを作成',
    'Have an account? Sign in': 'アカウントをお持ちですか？ サインイン',
    // 他の必要な翻訳を追加
    'Your passwords must match': 'パスワードが一致しません',
    'Password must have special characters': 'パスワードには特殊文字を含む必要があります.',
    'Password must have upper case letters': 'パスワードには大文字を含む必要があります.',
    'Password must have at least 8 characters': 'パスワードは8文字以上を入力して下さい.',
  },
});

const Container = styled(View)`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const SignUp = () => {
  const { route } = useAuthenticator(context => [context.route]);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (route === 'authenticated') {
      navigate('/prediction/map', { replace: true });
    }
  }, [route, navigate]);

  return (
    <Container>
      <Authenticator>
        <>
          {({ signOut, user }: any) => (
            <main>
              <h1>Hello {user.username}</h1>
              <button onClick={signOut}>Sign out</button>
            </main>
          )}
          <CircularProgress
            sx={{ position: 'fixed', top: '50%', left: 0, right: 0, margin: '0 auto' }}
            color="success"
          />
        </>
      </Authenticator>
    </Container>
  );
};

export default SignUp;
